import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  IAdvisoryBuyerPaginatedResponse,
  getAdvisoryBuyerPaginated,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { AdvisoryBuyerModalMode } from "./enums";
import { IAdvisoryBuyerModalData } from "./types";

const initialState = {
  advisoryBuyerData: null as Nullable<IAdvisoryBuyerPaginatedResponse["edges"]>,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: AdvisoryBuyerModalMode.VIEW,
    open: false,
    loading: false,
  } as IAdvisoryBuyerModalData,
};

export const fetchAdvisoryBuyerList = createAsyncThunk(
  "advisory/fetchAdvisoryBuyerList",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getAdvisoryBuyerPaginated(filters);
    return response;
  }
);

const advisoryBuyerSlice = createSlice({
  name: "advisoryBuyer",
  initialState,
  reducers: {
    setAdvisoryBuyerModalData: (
      state,
      action: PayloadAction<IAdvisoryBuyerModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeAdvisoryBuyerModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setAdvisoryBuyerModalLoading: (state, action: PayloadAction<boolean>) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAdvisoryBuyerList.fulfilled, (state, action) => {
      if (!action.payload) return;
      return {
        ...state,
        advisoryBuyerData: action.payload
          ?.edges as IAdvisoryBuyerPaginatedResponse["edges"],
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchAdvisoryBuyerList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setAdvisoryBuyerModalData,
  closeAdvisoryBuyerModal,
  setAdvisoryBuyerModalLoading,
} = advisoryBuyerSlice.actions;

export default advisoryBuyerSlice.reducer;
